module.exports = __webpack_public_path__ + "static/6265af8d210305d5a72cb32244786247.png";